import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomizeOrdersService } from '../services/customize-order.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Globals } from "../globals";
import { TranslateService } from '@ngx-translate/core';
import { ComplainsService } from "app/services/complains.service";

@Component({
  selector: 'app-complains-modal',
  templateUrl: './complains-modal.component.html',
  styleUrls: ['./complains-modal.component.css']
})
export class ComplainsModalComponent implements OnInit {

  complainDetails: any = null;
  hasEditPrivilage: boolean = false;
  complainStatus: any = [];
  image = null;
  sendNotification: boolean = false;
  message: string = "";
  department: string = "";
  departmentsArr: any = [];
  subDepartmentsArr: any = [];
  subDepartment: string = "";
  topic: string = "";
  topicsArr: any = [
    { id: "INTERNAL", name: 'complains.internal' },
    { id: "EXTERNAL", name: 'complains.external' }
  ];
  isAgent: boolean = false;
  summary: string = "";
  historyArr: any = [];
  rolledback: boolean = false;
  rollbackDescription: string = '';
  rollbackHistoryArr: any = [];

  constructor(public dialogRef: MatDialogRef<ComplainsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private customizeOrdersService: CustomizeOrdersService,
    private sanitizer: DomSanitizer, private complainsService: ComplainsService,
    private globals: Globals, private translate: TranslateService) { }

  ngOnInit(): void {
    const { complainDetails, hasEditPrivilage, isAgent } = this.data;
    this.isAgent = isAgent;
    this.complainDetails = complainDetails;
    this.hasEditPrivilage = hasEditPrivilage;
    this.department = this.complainDetails.department.toLowerCase();
    // this.subDepartment = this.complainDetails.subDepartment;
    this.topic = this.complainDetails.topic;
    this.summary = this.complainDetails.summary;
    this.departmentsArr = this.globals.getComplainsDepartments();
    // this.subDepartmentsArr = this.globals.getComplainsSubDepartments(this.department, true);
    this.complainStatus = this.globals.getComplainsStatus(this.isAgent);
    this.getPhoto(this.complainDetails.photo);
    this.complainsService.getComplainUpdates(this.complainDetails.id).subscribe(result => {
      this.historyArr = result;
    });
    if (this.complainDetails.rolledback) {
      this.complainsService.getComplainRollbackHistory(this.complainDetails.id).subscribe(result => {
        this.rollbackHistoryArr = result;
      });
    }
    setTimeout(() => {
      var modal = document.querySelector(".mat-dialog-container");
      if (modal) {
        modal.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 500);
  }

  cancel() {
    this.dialogRef.close();
  }

  getPhoto(path) {
    if (path != "" && path != null) {
      this.customizeOrdersService.getImage(path).subscribe((result: any) => {
        var binary = '';
        var bytes = new Uint8Array(result);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        let img = window.btoa(binary);
        this.image = this.sanitizer.bypassSecurityTrustUrl('data:image/jpg;base64, ' + img);
      });
    }
  }

  update() {
    let data = {
      "department": this.department.toUpperCase(),
      "status": this.globals.getComplainStatusForUpdate(this.complainDetails.status),
      "subDepartment": this.subDepartment,
      "topic": this.topic,
      "summary": this.summary
    };
    this.complainsService.updateComplain(data, this.complainDetails.id).subscribe(result => {
      this.globals.presentSuccessToast(this.translate.instant("complains.success"));
      this.dialogRef.close(true);
    });
  }

  send() {

    if (this.message.length > 255) {
      this.globals.presentErrorToast(this.translate.instant("general.msgError"));
      return false;
    }

    var data =
    {
      "message": this.message,
    }

    this.complainsService.sendMessageToAgent(data, this.complainDetails.id).subscribe(result => {
      this.dialogRef.close();
      this.globals.presentSuccessToast(this.translate.instant("general.sendSuccess"));
    });
  }

  getSubDepartments() {
    // this.subDepartmentsArr = this.globals.getComplainsSubDepartments(this.department, true);
  }

  acknowledgeChanged(item) {
    this.complainsService.updateAckhnolegde(this.complainDetails.id, item.id).subscribe(result => {
      this.dialogRef.close();
      this.globals.presentSuccessToast(this.translate.instant("complains.success"));
    });
  }

  getStatusName(status) {
    let name = this.complainStatus.filter(item => item.id == status)[0]?.name;
    return name ? name : "-";
  }

  rollbackComplain() {
    this.complainsService.rollbackComplain(this.complainDetails.id, {
      description: this.rollbackDescription
    }).subscribe(result => {
      this.dialogRef.close(true);
      this.globals.presentSuccessToast(this.translate.instant("complains.success"));
    });
  }
} 
